import { useQueryClient } from '@tanstack/react-query'
import { refreshIcon } from 'components/Icons'
import { JSX } from 'react'

export const RefreshButton = (): JSX.Element => {
  const queryClient = useQueryClient()

  const handleRefresh = (): void => {
    void queryClient.invalidateQueries({ queryKey: ['dashboard'] })
  }

  return (
    <button onClick={handleRefresh} title='Refresh' className='flex-1 rounded-md bg-brand p-2 shadow-xs dark:shadow-[0_12px_32px_-14px_rgba(0,0,0,0.7)] dark:ring-1 dark:ring-white/3 hover:bg-brand/70'>
      {refreshIcon}
    </button>
  )
}
